export default "__VITE_ASSET__Dp9mTeBq__"